module.exports = __webpack_public_path__ + "img/home-slider1.ec22c5c8.jpg";